import * as React from "react";
import { observer } from "mobx-react";
import { Grid, MenuItem, Box, BoxProps } from "@material-ui/core";
import parse from "html-react-parser";
import { MUISelect, FormSettingsRow, themeVariables } from "..";
import { tl } from "../../../../utils";
import * as styles from "./styles.scss";

interface IProps extends BoxProps {
  list: any[];
  value: number | "new";
  namePeriod?: boolean;
  trialPeriod?: string;
  changeValue: (value: number) => void;
  label: string;
  isDescription?: boolean;
  hint?: string;
}

export const BenefitField = observer(
  ({
    list,
    value,
    namePeriod,
    trialPeriod,
    changeValue,
    label,
    isDescription,
    hint,
    ...boxProps
  }: IProps) => {
    const getMonthPlural = (period: number) =>
      period === 1
        ? tl("месяц")
        : period > 1 && period < 5
        ? tl("месяца")
        : tl("месяцев");

    const itemSelected = list?.find((item) => item.id === value);
    return (
      <FormSettingsRow label={label} hint={hint}>
        <Grid container spacing={1} alignItems="center" justifyContent="space-between">
          <Grid item xs>
            <Box clone bgcolor={themeVariables.palette.common.white}>
              <MUISelect
                variant="outlined"
                value={value}
                fullWidth
                onChange={(evt: any) => {
                  changeValue(evt.target.value);
                }}
              >
                {list?.map((item: any) =>
                  item.price === null ? null : (
                    <MenuItem value={item.id} key={`item-${item.id}`}>
                      {trialPeriod && item.price === 0
                        ? trialPeriod
                        : namePeriod
                        ? `${item.period} ${getMonthPlural(item.period)}`
                        : item.name
                        ? item.name
                        : !item.price
                        ? tl("Бесплатно")
                        : ""}
                    </MenuItem>
                  )
                )}
              </MUISelect>
            </Box>
          </Grid>
          <Grid item>{boxProps.children}</Grid>
          {isDescription && itemSelected?.settings?.description ? (
            <Grid item xs={12}>
              <Box
                maxWidth="380px"
                color={themeVariables.palette.grey[600]}
                className={styles.description}
              >
                {parse(itemSelected?.settings?.description, {
                  replace: function(domNode) {
                    if (domNode.type === "script") {
                      var script = document.createElement("script");
                      script.src = domNode.attribs.src;
                      script.type = domNode.attribs.type;
                      script.async = true;
                      script.defer = true;
                      document.head.appendChild(script);
                    }
                  },
                })}
              </Box>
            </Grid>
          ) : null}
        </Grid>
      </FormSettingsRow>
    );
  }
);
